import { render, staticRenderFns } from "./WorkRadio.vue?vue&type=template&id=457ee928"
import script from "./WorkRadio.vue?vue&type=script&lang=js"
export * from "./WorkRadio.vue?vue&type=script&lang=js"
import style0 from "./WorkRadio.vue?vue&type=style&index=0&id=457ee928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports